(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tt-farm-image-carousel"] && !Shopify.designMode) return;
  try {
    
  const TFC_REDUCED_MOTION_QUERY = window.matchMedia('(prefers-reduced-motion: reduce)');

  /** Delay before autoplay resumes after a manual interaction (arrow/dot click). */
  const TFC_RESUME_AFTER_INTERACTION_MS = 4000;

  class TTFarmCarouselControls extends HTMLElement {
    #initialized = false;
    #resizeQueued = false;
    #section = null;
    #track = null;
    #slides = [];
    #dots = null;
    #currentIndex = 0;
    #autoplayTimer;
    #resumeTimer;
    #hoverPaused = false;
    #interactionPaused = false;
    /** @type {ResizeObserver | null} */
    #resizeObserver = null;

    connectedCallback() {
      requestAnimationFrame(this.#initialize);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.#handleClick);
      this.#section?.removeEventListener('pointerenter', this.#handlePointerEnter);
      this.#section?.removeEventListener('pointerleave', this.#handlePointerLeave);
      this.#section?.removeEventListener('focusin', this.#handleFocusIn);
      this.#section?.removeEventListener('focusout', this.#handleFocusOut);
      this.#track?.removeEventListener('touchstart', this.#handleTouchStart);
      this.#track?.removeEventListener('touchend', this.#handleTouchEnd);
      this.#track?.removeEventListener('keydown', this.#handleKeydown);
      window.removeEventListener('resize', this.#handleResize);
      document.removeEventListener('visibilitychange', this.#handleVisibilityChange);
      TFC_REDUCED_MOTION_QUERY.removeEventListener('change', this.#handleReducedMotionChange);
      this.#resizeObserver?.disconnect();
      this.#resizeObserver = null;
      this.#clearAutoplayTimer();
      window.clearTimeout(this.#resumeTimer);
      this.#initialized = false;
    }

    #initialize = () => {
      if (!this.isConnected || this.#initialized) return;

      this.#section = this.closest('.tt-farm-carousel');
      this.#track = this.#section?.querySelector('[data-track]') ?? null;
      this.#dots = this.querySelector('[data-page-dots]');

      if (!this.#section || !this.#track) {
        requestAnimationFrame(this.#initialize);
        return;
      }

      this.#slides = Array.from(this.#track.querySelectorAll('[data-slide]'));
      if (!this.#slides.length) return;

      this.#initialized = true;
      this.addEventListener('click', this.#handleClick);
      this.#section.addEventListener('pointerenter', this.#handlePointerEnter);
      this.#section.addEventListener('pointerleave', this.#handlePointerLeave);
      this.#section.addEventListener('focusin', this.#handleFocusIn);
      this.#section.addEventListener('focusout', this.#handleFocusOut);
      this.#track.addEventListener('touchstart', this.#handleTouchStart, { passive: true });
      this.#track.addEventListener('touchend', this.#handleTouchEnd, { passive: true });
      this.#track.addEventListener('keydown', this.#handleKeydown);
      window.addEventListener('resize', this.#handleResize);
      document.addEventListener('visibilitychange', this.#handleVisibilityChange);
      TFC_REDUCED_MOTION_QUERY.addEventListener('change', this.#handleReducedMotionChange);

      // The theme editor's device-preview buttons (and some mobile browser
      // rotations) resize this section's container without ever firing a
      // window "resize" event, since only the preview iframe/container
      // changes size. A ResizeObserver catches those cases too.
      if (typeof ResizeObserver === 'function') {
        this.#resizeObserver = new ResizeObserver(this.#handleResize);
        this.#resizeObserver.observe(this.#section);
      }

      this.#renderDots();
      this.#goToPage(0, { animate: false });
      this.#syncControls();
      this.#startAutoplay();
    };

    #touchStartX = 0;

    /** @param {TouchEvent} event */
    #handleTouchStart = (event) => {
      this.#touchStartX = event.changedTouches[0]?.clientX ?? 0;
    };

    /** @param {TouchEvent} event */
    #handleTouchEnd = (event) => {
      const endX = event.changedTouches[0]?.clientX ?? 0;
      const delta = endX - this.#touchStartX;
      const threshold = 40;

      if (Math.abs(delta) < threshold) return;

      if (delta < 0) {
        this.#goToPage(this.#getCurrentPageIndex() + 1, { wrap: true });
      } else {
        this.#goToPage(this.#getCurrentPageIndex() - 1, { wrap: true });
      }
      this.#registerInteraction();
    };

    /** @param {KeyboardEvent} event */
    #handleKeydown = (event) => {
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        this.#goToPage(this.#getCurrentPageIndex() + 1, { wrap: true });
        this.#registerInteraction();
      } else if (event.key === 'ArrowLeft') {
        event.preventDefault();
        this.#goToPage(this.#getCurrentPageIndex() - 1, { wrap: true });
        this.#registerInteraction();
      }
    };

    #handleClick = (event) => {
      const target = event.target instanceof Element ? event.target.closest('[data-action], [data-page-index]') : null;
      if (!(target instanceof HTMLElement)) return;

      event.preventDefault();

      if (target.dataset.pageIndex) {
        this.#goToPage(Number(target.dataset.pageIndex));
        this.#registerInteraction();
        return;
      }

      if (target.dataset.action === 'previous') {
        this.#goToPage(this.#getCurrentPageIndex() - 1, { wrap: true });
        this.#registerInteraction();
      } else if (target.dataset.action === 'next') {
        this.#goToPage(this.#getCurrentPageIndex() + 1, { wrap: true });
        this.#registerInteraction();
      }
    };

    /** @param {PointerEvent} event */
    #handlePointerEnter = (event) => {
      if (event.pointerType && event.pointerType !== 'mouse') return;
      this.#hoverPaused = true;
      this.#stopAutoplay();
    };

    /** @param {PointerEvent} event */
    #handlePointerLeave = (event) => {
      if (event.pointerType && event.pointerType !== 'mouse') return;
      this.#hoverPaused = false;
      this.#startAutoplay();
    };

    #handleFocusIn = () => {
      this.#hoverPaused = true;
      this.#stopAutoplay();
    };

    /** @param {FocusEvent} event */
    #handleFocusOut = (event) => {
      if (event.relatedTarget instanceof Node && this.#section?.contains(event.relatedTarget)) return;
      this.#hoverPaused = false;
      this.#startAutoplay();
    };

    #handleVisibilityChange = () => {
      if (document.hidden) {
        this.#stopAutoplay();
        return;
      }
      this.#startAutoplay();
    };

    #handleReducedMotionChange = () => {
      this.#startAutoplay();
    };

    #handleResize = () => {
      if (this.#resizeQueued) return;

      this.#resizeQueued = true;
      requestAnimationFrame(() => {
        this.#resizeQueued = false;

        this.#hoverPaused = Boolean(this.#section && this.#section.matches(':hover'));

        const currentPageIndex = this.#getCurrentPageIndex();
        this.#renderDots();
        this.#goToPage(currentPageIndex, { animate: false });
        this.#syncControls();
        this.#startAutoplay();
      });
    };

    #getNumberAttribute(name, fallback) {
      const value = Number(this.dataset[name]);
      return Number.isFinite(value) && value > 0 ? value : fallback;
    }

    #getItemsPerPage() {
      if (window.innerWidth >= 1200) return this.#getNumberAttribute('desktopColumns', 4);
      if (window.innerWidth >= 990) return this.#getNumberAttribute('laptopColumns', 3);
      if (window.innerWidth >= 750) return this.#getNumberAttribute('tabletColumns', 2);
      return this.#getNumberAttribute('mobileColumns', 1);
    }

    #getPageStartIndexes() {
      const itemsPerPage = this.#getItemsPerPage();
      const totalItems = this.#slides.length;

      if (!itemsPerPage || !totalItems) return [];

      return Array.from({ length: Math.ceil(totalItems / itemsPerPage) }, (_, index) => index * itemsPerPage);
    }

    #getPageCount() {
      return this.#getPageStartIndexes().length;
    }

    #getCurrentPageIndex() {
      const pageStartIndexes = this.#getPageStartIndexes();
      if (!pageStartIndexes.length) return 0;

      let closestPageIndex = 0;
      let smallestDistance = Infinity;

      pageStartIndexes.forEach((startIndex, pageIndex) => {
        const distance = Math.abs(startIndex - this.#currentIndex);
        if (distance < smallestDistance) {
          smallestDistance = distance;
          closestPageIndex = pageIndex;
        }
      });

      return closestPageIndex;
    }

    #renderDots() {
      if (!this.#dots) return;

      const pageCount = this.#getPageCount();
      this.#dots.hidden = pageCount <= 1;

      if (this.#dots.childElementCount === pageCount) return;

      this.#dots.replaceChildren();

      const fragment = document.createDocumentFragment();

      for (let pageIndex = 0; pageIndex < pageCount; pageIndex += 1) {
        const item = document.createElement('li');
        const button = document.createElement('button');
        const text = document.createElement('span');

        button.type = 'button';
        button.dataset.pageIndex = String(pageIndex);
        button.setAttribute('aria-label', `Go to image ${pageIndex + 1} of ${pageCount}`);
        button.setAttribute('aria-selected', pageIndex === 0 ? 'true' : 'false');

        text.className = 'visually-hidden';
        text.textContent = `Page ${pageIndex + 1}`;

        button.append(text);
        item.append(button);
        fragment.append(item);
      }

      this.#dots.append(fragment);
    }

    #syncControls() {
      const currentPageIndex = this.#getCurrentPageIndex();
      const pageCount = this.#getPageCount();

      this.#dots?.querySelectorAll('[data-page-index]').forEach((button, index) => {
        button.setAttribute('aria-selected', index === currentPageIndex ? 'true' : 'false');
      });

      const previous = this.querySelector('[data-action="previous"]');
      const next = this.querySelector('[data-action="next"]');

      if (previous instanceof HTMLButtonElement) {
        previous.disabled = pageCount <= 1;
        previous.hidden = pageCount <= 1;
      }

      if (next instanceof HTMLButtonElement) {
        next.disabled = pageCount <= 1;
        next.hidden = pageCount <= 1;
      }
    }

    #goToPage(pageIndex, options = {}) {
      const { animate = true, wrap = false } = options;
      const pageStartIndexes = this.#getPageStartIndexes();

      if (!this.#slides.length || !pageStartIndexes.length || !this.#track) return;

      let targetPageIndex = pageIndex;

      if (wrap) {
        if (targetPageIndex < 0) targetPageIndex = pageStartIndexes.length - 1;
        if (targetPageIndex >= pageStartIndexes.length) targetPageIndex = 0;
      } else {
        targetPageIndex = Math.max(0, Math.min(targetPageIndex, pageStartIndexes.length - 1));
      }

      const targetSlideIndex = pageStartIndexes[targetPageIndex];
      if (targetSlideIndex == null) return;

      this.#currentIndex = targetSlideIndex;

      const targetSlide = this.#slides[targetSlideIndex];
      if (!targetSlide) return;

      // .tt-farm-carousel__track is `position: relative`, which makes it the
      // offsetParent for every slide inside it, so offsetLeft here is always
      // the slide's true distance from the start of the track regardless of
      // any transform currently applied.
      const offset = targetSlide.offsetLeft;

      this.#track.style.transition = animate ? '' : 'none';
      this.#track.style.transform = `translateX(-${offset}px)`;

      if (!animate) {
        // Force layout so the next transform re-enables transitions cleanly.
        void this.#track.offsetHeight;
        this.#track.style.transition = '';
      }

      this.#syncControls();
    }

    #shouldAutoplay() {
      return (
        this.dataset.autoplay === 'true' &&
        !document.hidden &&
        !this.#hoverPaused &&
        !this.#interactionPaused &&
        !TFC_REDUCED_MOTION_QUERY.matches &&
        this.#getPageCount() > 1
      );
    }

    #getAutoplayDelay() {
      return this.#getNumberAttribute('autoplaySpeed', 4) * 1000;
    }

    #clearAutoplayTimer() {
      window.clearInterval(this.#autoplayTimer);
      this.#autoplayTimer = undefined;
    }

    #stopAutoplay() {
      this.#clearAutoplayTimer();
    }

    #startAutoplay() {
      this.#clearAutoplayTimer();
      if (!this.#shouldAutoplay()) return;

      this.#autoplayTimer = window.setInterval(() => {
        this.#goToPage(this.#getCurrentPageIndex() + 1, { wrap: true });
      }, this.#getAutoplayDelay());
    }

    /**
     * Called when the user manually changes slides via an arrow, dot, swipe or key press.
     * Pauses autoplay, then resumes it automatically after a short idle period.
     */
    #registerInteraction() {
      this.#interactionPaused = true;
      this.#stopAutoplay();

      window.clearTimeout(this.#resumeTimer);
      this.#resumeTimer = window.setTimeout(() => {
        this.#interactionPaused = false;
        this.#startAutoplay();
      }, TFC_RESUME_AFTER_INTERACTION_MS);
    }
  }

  if (!customElements.get('tt-farm-carousel-controls')) {
    customElements.define('tt-farm-carousel-controls', TTFarmCarouselControls);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tt-testimonials"] && !Shopify.designMode) return;
  try {
    
  const TT_REDUCED_MOTION_QUERY = window.matchMedia('(prefers-reduced-motion: reduce)');

  /** Delay before autoplay resumes after a manual interaction (arrow/dot click). */
  const TT_RESUME_AFTER_INTERACTION_MS = 4000;

  class TTTestimonialsControls extends HTMLElement {
    #initialized = false;
    #resizeQueued = false;
    #slideshow = null;
    #dots = null;
    #autoplayTimer;
    #resumeTimer;
    #hoverPaused = false;
    #interactionPaused = false;
    /** @type {ResizeObserver | null} */
    #resizeObserver = null;

    connectedCallback() {
      requestAnimationFrame(this.#initialize);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.#handleClick);
      this.#slideshow?.removeEventListener('slideshow:select', this.#handleSlideshowSelect);
      this.#slideshow?.removeEventListener('pointerenter', this.#handlePointerEnter);
      this.#slideshow?.removeEventListener('pointerleave', this.#handlePointerLeave);
      this.#slideshow?.removeEventListener('focusin', this.#handleFocusIn);
      this.#slideshow?.removeEventListener('focusout', this.#handleFocusOut);
      window.removeEventListener('resize', this.#handleResize);
      document.removeEventListener('visibilitychange', this.#handleVisibilityChange);
      TT_REDUCED_MOTION_QUERY.removeEventListener('change', this.#handleReducedMotionChange);
      this.#resizeObserver?.disconnect();
      this.#resizeObserver = null;
      this.#clearAutoplayTimer();
      window.clearTimeout(this.#resumeTimer);
      this.#initialized = false;
    }

    #initialize = () => {
      if (!this.isConnected || this.#initialized) return;

      this.#slideshow = this.closest('slideshow-component');
      this.#dots = this.querySelector('[data-page-dots]');

      if (!this.#slideshow || !this.#dots || !(this.#slideshow.refs?.scroller instanceof HTMLElement)) {
        requestAnimationFrame(this.#initialize);
        return;
      }

      this.#initialized = true;
      this.addEventListener('click', this.#handleClick);
      this.#slideshow.addEventListener('slideshow:select', this.#handleSlideshowSelect);
      this.#slideshow.addEventListener('pointerenter', this.#handlePointerEnter);
      this.#slideshow.addEventListener('pointerleave', this.#handlePointerLeave);
      this.#slideshow.addEventListener('focusin', this.#handleFocusIn);
      this.#slideshow.addEventListener('focusout', this.#handleFocusOut);
      window.addEventListener('resize', this.#handleResize);
      document.addEventListener('visibilitychange', this.#handleVisibilityChange);
      TT_REDUCED_MOTION_QUERY.addEventListener('change', this.#handleReducedMotionChange);

      // The theme editor's device-preview buttons (and some mobile browser
      // rotations) resize this section's container without ever firing a
      // window "resize" event, since only the preview iframe/container
      // changes size. A ResizeObserver catches those cases too.
      if (typeof ResizeObserver === 'function') {
        this.#resizeObserver = new ResizeObserver(this.#handleResize);
        this.#resizeObserver.observe(this.#slideshow);
      }

      this.#renderDots();
      this.#syncControls();
      this.#startAutoplay();
    };

    #handleClick = (event) => {
      const target = event.target instanceof Element ? event.target.closest('[data-action], [data-page-index]') : null;
      if (!(target instanceof HTMLElement)) return;

      event.preventDefault();

      if (target.dataset.pageIndex) {
        this.#goToPage(Number(target.dataset.pageIndex));
        this.#registerInteraction();
        return;
      }

      const currentPageIndex = this.#getCurrentPageIndex();
      if (target.dataset.action === 'previous') {
        this.#goToPage(currentPageIndex - 1, { wrap: true });
        this.#registerInteraction();
      } else if (target.dataset.action === 'next') {
        this.#goToPage(currentPageIndex + 1, { wrap: true });
        this.#registerInteraction();
      }
    };

    /** @param {PointerEvent} event */
    #handlePointerEnter = (event) => {
      // Ignore touch/pen pointers so tapping doesn't get treated as a hover-hold.
      if (event.pointerType && event.pointerType !== 'mouse') return;
      this.#hoverPaused = true;
      this.#stopAutoplay();
    };

    /** @param {PointerEvent} event */
    #handlePointerLeave = (event) => {
      if (event.pointerType && event.pointerType !== 'mouse') return;
      this.#hoverPaused = false;
      this.#startAutoplay();
    };

    #handleFocusIn = () => {
      this.#hoverPaused = true;
      this.#stopAutoplay();
    };

    /** @param {FocusEvent} event */
    #handleFocusOut = (event) => {
      if (event.relatedTarget instanceof Node && this.#slideshow?.contains(event.relatedTarget)) return;
      this.#hoverPaused = false;
      this.#startAutoplay();
    };

    #handleVisibilityChange = () => {
      if (document.hidden) {
        this.#stopAutoplay();
        return;
      }

      this.#startAutoplay();
    };

    #handleReducedMotionChange = () => {
      this.#startAutoplay();
    };

    #handleResize = () => {
      if (this.#resizeQueued) return;

      this.#resizeQueued = true;
      requestAnimationFrame(() => {
        this.#resizeQueued = false;

        // Resizing the viewport (rotating a device, dragging devtools) doesn't
        // always fire a matching pointerenter/pointerleave pair, so #hoverPaused
        // can get stuck true and silently block autoplay forever. Re-derive it
        // from the actual pointer position instead of trusting the last event.
        this.#hoverPaused = Boolean(this.#slideshow && this.#slideshow.matches(':hover'));

        const currentPageIndex = this.#getCurrentPageIndex();
        this.#renderDots();
        this.#goToPage(currentPageIndex, { animate: false });
        this.#syncControls();
        this.#startAutoplay();
      });
    };

    #handleSlideshowSelect = () => {
      this.#syncControls();
    };

    #getNumberAttribute(name, fallback) {
      const value = Number(this.dataset[name]);
      return Number.isFinite(value) && value > 0 ? value : fallback;
    }

    #getSlides() {
      return Array.isArray(this.#slideshow?.slides) ? this.#slideshow.slides : [];
    }

    #getItemsPerPage() {
      if (window.innerWidth >= 990) return this.#getNumberAttribute('desktopColumns', 4);
      if (window.innerWidth >= 750) return this.#getNumberAttribute('tabletColumns', 2);
      return this.#getNumberAttribute('mobileColumns', 1);
    }

    #getPageStartIndexes() {
      const itemsPerPage = this.#getItemsPerPage();
      const totalItems = this.#getSlides().length || this.#getNumberAttribute('totalItems', 0);

      if (!itemsPerPage || !totalItems) return [];

      return Array.from({ length: Math.ceil(totalItems / itemsPerPage) }, (_, index) => index * itemsPerPage);
    }

    #getPageCount() {
      return this.#getPageStartIndexes().length;
    }

    #getCurrentPageIndex() {
      const pageStartIndexes = this.#getPageStartIndexes();
      if (!pageStartIndexes.length) return 0;

      const currentSlideIndex = this.#slideshow?.current ?? 0;

      let closestPageIndex = 0;
      let smallestDistance = Infinity;

      pageStartIndexes.forEach((startIndex, pageIndex) => {
        const distance = Math.abs(startIndex - currentSlideIndex);
        if (distance < smallestDistance) {
          smallestDistance = distance;
          closestPageIndex = pageIndex;
        }
      });

      return closestPageIndex;
    }

    #renderDots() {
      if (!this.#dots) return;

      const pageCount = this.#getPageCount();
      this.#dots.hidden = pageCount <= 1;

      if (this.#dots.childElementCount === pageCount) return;

      this.#dots.replaceChildren();

      const fragment = document.createDocumentFragment();

      for (let pageIndex = 0; pageIndex < pageCount; pageIndex += 1) {
        const item = document.createElement('li');
        const button = document.createElement('button');
        const text = document.createElement('span');

        button.type = 'button';
        button.dataset.pageIndex = String(pageIndex);
        button.setAttribute('aria-label', `Go to testimonials page ${pageIndex + 1} of ${pageCount}`);
        button.setAttribute('aria-selected', pageIndex === 0 ? 'true' : 'false');

        text.className = 'visually-hidden';
        text.textContent = `Page ${pageIndex + 1}`;

        button.append(text);
        item.append(button);
        fragment.append(item);
      }

      this.#dots.append(fragment);
    }

    #syncControls() {
      const currentPageIndex = this.#getCurrentPageIndex();
      const pageCount = this.#getPageCount();

      this.#dots?.querySelectorAll('[data-page-index]').forEach((button, index) => {
        button.setAttribute('aria-selected', index === currentPageIndex ? 'true' : 'false');
      });

      const previous = this.querySelector('[data-action="previous"]');
      const next = this.querySelector('[data-action="next"]');

      if (previous instanceof HTMLButtonElement) {
        previous.disabled = pageCount <= 1;
        previous.hidden = pageCount <= 1;
      }

      if (next instanceof HTMLButtonElement) {
        next.disabled = pageCount <= 1;
        next.hidden = pageCount <= 1;
      }
    }

    #goToPage(pageIndex, options = {}) {
      const { animate = true, wrap = false } = options;
      const slides = this.#getSlides();
      const pageStartIndexes = this.#getPageStartIndexes();

      if (!slides.length || !pageStartIndexes.length || !this.#slideshow) return;

      let targetPageIndex = pageIndex;

      if (wrap) {
        if (targetPageIndex < 0) targetPageIndex = pageStartIndexes.length - 1;
        if (targetPageIndex >= pageStartIndexes.length) targetPageIndex = 0;
      } else {
        targetPageIndex = Math.max(0, Math.min(targetPageIndex, pageStartIndexes.length - 1));
      }

      const targetSlideIndex = pageStartIndexes[targetPageIndex];
      if (targetSlideIndex == null) return;

      const slideshowCurrentBefore = this.#slideshow.current;

      this.#slideshow.select(targetSlideIndex, undefined, { animate });

      // A breakpoint change can leave the slideshow's own slide index out of sync
      // with the page index this component just computed (its `select()` silently
      // no-ops if the DOM element at `targetSlideIndex` happens to already be the
      // current slide). When that happens, nudge to the very next raw slide instead
      // so autoplay can't get permanently stuck pointing at a page that never advances.
      requestAnimationFrame(() => {
        if (
          wrap &&
          pageStartIndexes.length > 1 &&
          this.#slideshow?.current === slideshowCurrentBefore &&
          typeof this.#slideshow?.next === 'function'
        ) {
          this.#slideshow.next(undefined, { animate });
        }

        this.#syncControls();
      });
    }

    #shouldAutoplay() {
      return (
        this.dataset.autoplay === 'true' &&
        !document.hidden &&
        !this.#hoverPaused &&
        !this.#interactionPaused &&
        !TT_REDUCED_MOTION_QUERY.matches &&
        this.#getPageCount() > 1
      );
    }

    #getAutoplayDelay() {
      return this.#getNumberAttribute('autoplaySpeed', 5) * 1000;
    }

    #clearAutoplayTimer() {
      window.clearInterval(this.#autoplayTimer);
      this.#autoplayTimer = undefined;
    }

    #stopAutoplay() {
      this.#clearAutoplayTimer();
    }

    #startAutoplay() {
      this.#clearAutoplayTimer();
      if (!this.#shouldAutoplay()) return;

      this.#autoplayTimer = window.setInterval(() => {
        this.#goToPage(this.#getCurrentPageIndex() + 1, { wrap: true });
      }, this.#getAutoplayDelay());
    }

    /**
     * Called when the user manually changes testimonials via an arrow or dot click.
     * Pauses autoplay, then resumes it automatically after a short idle period.
     */
    #registerInteraction() {
      this.#interactionPaused = true;
      this.#stopAutoplay();

      window.clearTimeout(this.#resumeTimer);
      this.#resumeTimer = window.setTimeout(() => {
        this.#interactionPaused = false;
        this.#startAutoplay();
      }, TT_RESUME_AFTER_INTERACTION_MS);
    }
  }

  if (!customElements.get('tt-testimonials-controls')) {
    customElements.define('tt-testimonials-controls', TTTestimonialsControls);
  }

  } catch(e) { console.error(e); }
})();
})();
